import { Timestamp } from "@bufbuild/protobuf";
import {
  type GetUserRequest,
  GetUserResponse,
  type GetUsersRequest,
  GetUsersResponse,
  UserSensitive,
} from "schema/gen/es/chiikipoint/adminconsole/v2/service_pb";
import {
  TransactionGroup,
  User_Gender,
} from "schema/gen/es/chiikipoint/model/v2/model_pb";

import { debugLog } from "../../debug-log";
import { simulateDelay } from "./utils";

const transactionGroupsFromExample: TransactionGroup[] = (() => {
  const transactionGroups: TransactionGroup[] = [1, 2, 3].map(
    (i) =>
      new TransactionGroup({
        id: `2b0d7b3dcb6${i}`,
        transactionDetails: [
          {
            transaction: {
              id: "df880a2a-0101-45a7-a1cc-e2f4f7c1e4b7",
              groupId: "9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
              userId: "6ca9d764-5d2f-405a-b0a2-656eeac151ac",
              type: 2, // PAYMENT
              balanceAddId: "0191f997-35db-7d43-a6a0-652120513df6",
              amount: BigInt(-100),
              fundSourceId: "0191f997-b5fc-7732-9303-a06f08183c09",
              reason: "支払い",
              createdAt: {
                seconds: BigInt(1739634210),
                nanos: 0,
              },
              qrId: "テストQR",
            },
            store: {
              id: "8f0d2d9e-c9c9-4b4a-9f9c-0c5c9c9c9c9c",
              name: "みやポマート",
              fullAddress: "宮城県仙台市青葉区一番町１丁目３−２",
              city: "宮城県仙台市青葉区",
              location: {
                latitude: 38.25783587179756,
                longitude: 140.87284595831724,
              },
              category: "コンビニ",
              iconUrl: "/misc/storefront.png",
            },
            user: {
              gender: 1,
              ageGroup: BigInt(20),
            },
          },
        ],
      })
  );
  return [
    ...transactionGroups,
    new TransactionGroup({
      id: "03ef2817e92d",
      transactionDetails: [
        {
          transaction: {
            id: "62fca4da-36a5-4d14-9be2-df371067129f",
            groupId: "0f64f87e-24d5-4fc2-a0cd-067f51dc5efc",
            userId: "6ca9d764-5d2f-405a-b0a2-656eeac151ac",
            type: 2, // PAYMENT
            balanceAddId: "0191f997-35db-7d43-a6a0-652120513df6",
            amount: BigInt(-100),
            fundSourceId: "0191f997-b5fc-7732-9303-a06f08183c09",
            reason: "支払い",
            qrId: "返金",
            createdAt: {
              seconds: BigInt(1739634210),
              nanos: 0,
            },
          },
          store: {
            id: "8f0d2d9e-c9c9-4b4a-9f9c-0c5c9c9c9c9c",
            name: "みやポマート",
            fullAddress: "宮城県仙台市青葉区一番町１丁目３−２",
            city: "宮城県仙台市青葉区",
            location: {
              latitude: 38.25783587179756,
              longitude: 140.87284595831724,
            },
            category: "コンビニ",
            iconUrl: "/misc/storefront.png",
          },
          user: {
            ageGroup: BigInt(40),
            gender: 2,
          },
        },
        {
          transaction: {
            id: "06e4fd98-82d1-457d-b3bd-ccb62f83445c",
            groupId: "0f64f87e-24d5-4fc2-a0cd-067f51dc5efc",
            userId: "6ca9d764-5d2f-405a-b0a2-656eeac151ac",
            type: 3, // Refund
            balanceAddId: "0191f997-35db-7d43-a6a0-652120513df6",
            amount: BigInt(100),
            fundSourceId: "0191f997-b5fc-7732-9303-a06f08183c09",
            reason: "返金",
            createdAt: {
              seconds: BigInt(1739634210),
              nanos: 0,
            },
          },
          store: {
            id: "8f0d2d9e-c9c9-4b4a-9f9c-0c5c9c9c9c9c",
            name: "みやポマート",
            fullAddress: "宮城県仙台市青葉区一番町１丁目３−２",
            city: "宮城県仙台市青葉区",
            location: {
              latitude: 38.25783587179756,
              longitude: 140.87284595831724,
            },
            category: "コンビニ",
            iconUrl: "/misc/storefront.png",
          },
        },
      ],
    }),
    new TransactionGroup({
      id: "03ef2817e92d",
      transactionDetails: [
        {
          transaction: {
            id: "df880a2a-0101-45a7-a1cc-e2f4f7c1e4b7",
            groupId: "9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
            userId: "6ca9d764-5d2f-405a-b0a2-656eeac151ac",
            type: 2, // PAYMENT
            balanceAddId: "0191f997-35db-7d43-a6a0-652120513df6",
            amount: BigInt(-100),
            fundSourceId: "0191f997-b5fc-7732-9303-a06f08183c09",
            reason: "支払い",
            qrId: "精算",
            createdAt: {
              seconds: BigInt(1739634210),
              nanos: 0,
            },
          },
          store: {
            id: "8f0d2d9e-c9c9-4b4a-9f9c-0c5c9c9c9c9c",
            name: "みやポマート",
            fullAddress: "宮城県仙台市青葉区一番町１丁目３−２",
            city: "宮城県仙台市青葉区",
            location: {
              latitude: 38.25783587179756,
              longitude: 140.87284595831724,
            },
            category: "コンビニ",
            iconUrl: "/misc/storefront.png",
          },
          user: {
            ageGroup: BigInt(30),
            gender: 2,
          },
        },
        {
          transaction: {
            id: "1269da8b-8ff6-4a30-b36d-98210bd4f865",
            groupId: "9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
            userId: "6ca9d764-5d2f-405a-b0a2-656eeac151ac",
            type: 6, // REDEEM
            balanceAddId: "0191f997-35db-7d43-a6a0-652120513df6",
            amount: BigInt(100),
            fundSourceId: "0191f997-b5fc-7732-9303-a06f08183c09",
            reason: "精算",
            createdAt: {
              seconds: BigInt(1739634210),
              nanos: 0,
            },
          },
          store: {
            id: "8f0d2d9e-c9c9-4b4a-9f9c-0c5c9c9c9c9c",
            name: "みやポマート",
            fullAddress: "宮城県仙台市青葉区一番町１丁目３−２",
            city: "宮城県仙台市青葉区",
            location: {
              latitude: 38.25783587179756,
              longitude: 140.87284595831724,
            },
            category: "コンビニ",
            iconUrl: "/misc/storefront.png",
          },
        },
      ],
    }),
    new TransactionGroup({
      id: "03ef2817e92d",
      transactionDetails: [
        {
          transaction: {
            id: "df880a2a-0101-45a7-a1cc-e2f4f7c1e4b7",
            groupId: "9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
            userId: "6ca9d764-5d2f-405a-b0a2-656eeac151ac",
            type: 2, // PAYMENT
            balanceAddId: "0191f997-35db-7d43-a6a0-652120513df6",
            amount: BigInt(-100),
            fundSourceId: "0191f997-b5fc-7732-9303-a06f08183c09",
            reason: "支払い",
            qrId: "返金&精算",
            createdAt: {
              seconds: BigInt(1739634210),
              nanos: 0,
            },
          },
          store: {
            id: "8f0d2d9e-c9c9-4b4a-9f9c-0c5c9c9c9c9c",
            name: "みやポマート",
            fullAddress: "宮城県仙台市青葉区一番町１丁目３−２",
            city: "宮城県仙台市青葉区",
            location: {
              latitude: 38.25783587179756,
              longitude: 140.87284595831724,
            },
            category: "コンビニ",
            iconUrl: "/misc/storefront.png",
          },
          user: {
            ageGroup: BigInt(50),
            gender: 1,
          },
        },
        {
          transaction: {
            id: "774e64bb-614e-4f7e-b8d3-06c36bf7705a",
            groupId: "8c66f52a-2b76-4776-95b8-e7eb78f2c819",
            userId: "6ca9d764-5d2f-405a-b0a2-656eeac151ac",
            type: 3, // Refund
            balanceAddId: "0191f997-35db-7d43-a6a0-652120513df6",
            amount: BigInt(100),
            fundSourceId: "0191f997-b5fc-7732-9303-a06f08183c09",
            reason: "返金",
            createdAt: {
              seconds: BigInt(1739634210),
              nanos: 0,
            },
          },
          store: {
            id: "8f0d2d9e-c9c9-4b4a-9f9c-0c5c9c9c9c9c",
            name: "みやポマート",
            fullAddress: "宮城県仙台市青葉区一番町１丁目３−２",
            city: "宮城県仙台市青葉区",
            location: {
              latitude: 38.25783587179756,
              longitude: 140.87284595831724,
            },
            category: "コンビニ",
            iconUrl: "/misc/storefront.png",
          },
        },
        {
          transaction: {
            id: "2adb3cc9-13f4-48f3-9eaa-f87ecdc56e19",
            groupId: "8c66f52a-2b76-4776-95b8-e7eb78f2c819",
            userId: "6ca9d764-5d2f-405a-b0a2-656eeac151ac",
            type: 6, // REDEEM
            balanceAddId: "0191f997-35db-7d43-a6a0-652120513df6",
            amount: BigInt(0),
            fundSourceId: "0191f997-b5fc-7732-9303-a06f08183c09",
            reason: "精算",
            createdAt: {
              seconds: BigInt(1739634210),
              nanos: 0,
            },
          },
          store: {
            id: "8f0d2d9e-c9c9-4b4a-9f9c-0c5c9c9c9c9c",
            name: "みやポマート",
            fullAddress: "宮城県仙台市青葉区一番町１丁目３−２",
            city: "宮城県仙台市青葉区",
            location: {
              latitude: 38.25783587179756,
              longitude: 140.87284595831724,
            },
            category: "コンビニ",
            iconUrl: "/misc/storefront.png",
          },
        },
      ],
    }),
    new TransactionGroup({
      id: "3e7f8640d1de",
      transactionDetails: [
        {
          transaction: {
            id: "62c56c72-6b2d-4d58-b2ec-a6f963f46d87",
            groupId: "e0846d12-8700-49c0-ad53-3460d59d37af",
            userId: "6ca9d764-5d2f-405a-b0a2-656eeac151ac",
            type: 2, // PAYMENT
            balanceAddId: "0191f997-35db-7d43-a6a0-652120513df6",
            amount: BigInt(-100),
            fundSourceId: "0191f997-b5fc-7732-9303-a06f08183c09",
            reason: "支払い",
            createdAt: {
              seconds: BigInt(1739634210),
              nanos: 0,
            },
            qrId: "複数ソース",
          },
          store: {
            id: "8f0d2d9e-c9c9-4b4a-9f9c-0c5c9c9c9c9c",
            name: "みやポマート",
            fullAddress: "宮城県仙台市青葉区一番町１丁目３−２",
            city: "宮城県仙台市青葉区",
            location: {
              latitude: 38.25783587179756,
              longitude: 140.87284595831724,
            },
            category: "コンビニ",
            iconUrl: "/misc/storefront.png",
          },
          user: {
            ageGroup: BigInt(70),
            gender: 2,
          },
        },
        {
          transaction: {
            id: "ce287ced-e3ca-4342-b26a-687109e83fa9",
            groupId: "e0846d12-8700-49c0-ad53-3460d59d37af",
            userId: "6ca9d764-5d2f-405a-b0a2-656eeac151ac",
            type: 2, // PAYMENT
            balanceAddId: "ed1475ec-87e2-4952-9571-18589441df26",
            amount: BigInt(-100),
            fundSourceId: "0191f997-b5fc-7732-9303-a06f08183c09",
            reason: "支払い",
            createdAt: {
              seconds: BigInt(1739634210),
              nanos: 0,
            },
            qrId: "複数ソース",
          },
          store: {
            id: "8f0d2d9e-c9c9-4b4a-9f9c-0c5c9c9c9c9c",
            name: "みやポマート",
            fullAddress: "宮城県仙台市青葉区一番町１丁目３−２",
            city: "宮城県仙台市青葉区",
            location: {
              latitude: 38.25783587179756,
              longitude: 140.87284595831724,
            },
            category: "コンビニ",
            iconUrl: "/misc/storefront.png",
          },
        },
      ],
    }),
  ];
})();

export const mockGetUsers = async (
  req: GetUsersRequest,
): Promise<GetUsersResponse> => {
  debugLog("mockGetUsers", req.toJson());
  const users: UserSensitive[] = [
    new UserSensitive({
      id: "9a25ff08-2f81-4447-aa33-bc8a60ad4e9c",
      subscriptionId: "subscription-id",
      name: "サンプル太郎",
      cityAddress: "宮城県仙台市青葉区",
      gender: User_Gender.MALE,
      birthday: Timestamp.fromDate(new Date("1990-01-01")),
      createdAt: Timestamp.fromDate(new Date("2024-12-31")),
    }),
  ];
  await simulateDelay();
  return new GetUsersResponse({ users });
};

export const mockGetUser = async (
  _req: GetUserRequest,
): Promise<GetUserResponse> => {
  await simulateDelay();
  return new GetUserResponse({
    user: new UserSensitive({
      id: "9a25ff08-2f81-4447-aa33-bc8a60ad4e9c",
      subscriptionId: "subscription-id",
      name: "サンプル太郎",
      cityAddress: "宮城県仙台市青葉区",
      gender: User_Gender.MALE,
      birthday: Timestamp.fromDate(new Date("1990-01-01")),
      createdAt: Timestamp.fromDate(new Date("2024-12-31")),
    }),
    transactionGroups: transactionGroupsFromExample,
  });
};
